import script from "./HrList.vue?vue&type=script&setup=true&lang=js"
export * from "./HrList.vue?vue&type=script&setup=true&lang=js"

import "./HrList.vue?vue&type=style&index=0&id=5da1c55d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da1c55d"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem});
